import { normalizeLoaderDepth } from "@CommonUtils/pog/shelfLoader";
import type { TellOUnit } from "./proposal";

/** A unit the manager may type; "in" and "cm" are also the window's own units. */
export type TellOTypedUnit = "in" | "cm" | "mm";

const PER_INCH: Record<TellOTypedUnit, number> = { in: 1, cm: 2.54, mm: 25.4 };

/** A typed length in the window's unit, x100 (how the pog stores lengths). */
export const tellOLengthToX100 = (
  value: number,
  typedUnit: TellOTypedUnit | null,
  unit: TellOUnit,
): number => {
  const inUnit = typedUnit ? (value / PER_INCH[typedUnit]) * PER_INCH[unit] : value;
  return Math.round(inUnit * 100);
};

/** 150 -> 1.5. */
export const displayTellOLength = (x100: number) => Number((x100 / 100).toFixed(2));

/** 150 -> "1.5 in". */
export const formatTellOLength = (x100: number, unit: TellOUnit) =>
  `${displayTellOLength(x100)} ${unit}`;

/** A Fixtures page value: null when not set, so 0 ("never") stays distinct. */
export const normalizeLoaderDepthValue = (value: unknown): number | null => {
  if (value === null || value === undefined || value === "") return null;
  if (!Number.isFinite(Number(value))) return null;
  return normalizeLoaderDepth(value);
};
